var utils = function(){
    /**
     * Creates an alert based on an endpoint response
     * @param {*} response
     */
    function alertEndpointResponse(response,onCloseFunction){
        var icon = "error";
        if(response.status=="ok")
            icon = "success";

        var message = "";
        if(response.messages)
            message = response.messages.join("<br />");
        else if(response.message)
            message = response.message;
        else if(response)
            message = response;

        if($.type(message) !== 'string'){
            message = "Error";
        }

        var options = {
            icon: icon,
            onClose: function(){
                if(onCloseFunction){
                    onCloseFunction();
                }
            }
        };
        if(message.indexOf("<")>-1){
            options.html = message;
        }else{
            options.text = message;
        }
        Swal.fire(options);
    }

    return {
        "alertEndpointResponse":alertEndpointResponse
    };
}();
